import React, { useEffect, useState } from 'react';
import {
  Table,
  Divider,
  Button,
  Modal,
  InputNumber,
  Switch,
  Tooltip,
  Col,
  Row,
  Spin,
  Alert,
  Pagination,
} from 'antd';

import Icon, { RightOutlined, LoadingOutlined } from '@ant-design/icons';
import humps from 'humps';
import cx from 'classnames';
import { saveAs } from 'file-saver';

import * as IOCData from './IOCData';
import { STATUS } from '../../../../redux/constants';
import {
  defaultFilters,
  defaultPagination,
  defaultSorting,
} from '../../../../redux/constants/ioc';
import styles from './home.module.sass';
import { getQueryVariable } from '../../../../redux/utils';
import history from '../../../../redux/history';
import { useLocation } from 'react-router-dom';
import IOCDetail from './IOCDetail';
import { ReactComponent as no_results } from '../../../../assets/icons/no_results.svg';
import ThreatRankingHeader from './ThreatRankingHeader';
import mixpanel from 'mixpanel-browser';
import { createBrowserHistory } from 'history';
import { useDispatch, useSelector } from 'react-redux';
import { changeTitle } from '../../../../redux/actions/app';
import { AdvancedFilterView } from '../AdvancedFilterView/AdvancedFilterView';
import VersionCheck from '../../../../shared-components/VersionCheck';
import moment from 'moment-timezone';
import { applyFilters } from '../../../../redux/actions/filters';
import { selectOptionsByIndicator } from '../../../../redux/selectors/filters';
import CopyEndpoint from '../../../../shared-components/CopyEndpoint';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import { AdvancedFilterButton } from '../AdvancedFilterView/AdvancedFilterButton';
import Cookies from 'cookies-js';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';

function Home(props) {
  const {
    status,
    sortOrder,
    pagination,
    filters,
    sorting,
    iocList,
    updateIocList,
    updateIocListFromCache,
    paginationIocList,
    paginationIocListFromCache,
    filterSettings,
    activeThreatRankingEndpoint,
    endpointParams,
    selectedProfile,
    updateTag,
    threat_ranking_cached_flag,
    clearFilterProfile,
    feedStateFilterCategory,
    setFeedStateFilter,
  } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const previousLocation = useSelector((state) => state.router.location);
  let filterProfileApplied = useSelector(
    (state) => state?.filter?.appliedProfile,
  );
  const [manualExportModalVisible, setManualExportModalVisible] = useState();
  const [
    automatedExportModalVisible,
    setAutomatedExportModalVisible,
  ] = useState(false);
  const [exportLimit, setExportLimit] = useState(100);
  const [exportSwitchState, setExportSwitchState] = useState(false);
  const [exportDeduplicateState, setExportDeduplicateState] = useState(false);
  const [expandedRowsKeys, setExpandedRowsKeys] = useState([]);
  const [checkedFeedsFilter, setCheckedFeedsFilter] = useState({});
  const [checkedVendorsFilter, setCheckedVendorsFilter] = useState({});
  const [rowIndex, setRowIndex] = useState(null);
  const [feedStateFilterValue, setFeedStateFilterValue] = useState(
    feedStateFilterCategory,
  );
  const [feedType, setFeedType] = useState([]);
  const [filteredFeedSources, setFilteredFeedSources] = useState([]);
  const [
    clearVendorInputFilter,
    setClearVendorInputFilter,
  ] = useState(() => () => {});
  const [
    clearFeedInputFilter,
    setClearFeedInputFilter,
  ] = useState(() => () => {});
  const currentlySelectedProfile = useSelector(
    (state) => state?.filter?.selectedProfile,
  );
  const filterProfiles = useSelector((state) => state?.filter?.profiles);
  const [currentUUID, setCurrentUUID] = useState(null);
  const optionsByIndicator = useSelector((state) =>
    selectOptionsByIndicator(state),
  );

  const tableLoading = {
    spinning: props.status === STATUS.LOADING,
    indicator: <LoadingSilentPush size={80} positionCenter rounded />,
  };

  function useQuery() {
    return new URLSearchParams(window.location.search);
  }
  const q = useQuery();

  const applyFilterProfile = (filterProfile) => {
    if (filterProfile.length > 0) {
      filterProfile = filterProfile[0];
    } else {
      return;
    }

    const relativeDates = ['Today', 'Yesterday', 'Last 7 Days'];
    const filterProfileIndex = filterProfiles
      ?.map((f) => f.uuid)
      ?.indexOf(filterProfile.uuid);
    const conditionBlocks =
      filterProfiles[filterProfileIndex]?.condition_blocks;
    if (!conditionBlocks) {
      return;
    }
    const updatedProfile = {
      uuid: filterProfile.uuid,
      name: filterProfiles[filterProfileIndex]?.name,
      condition_blocks: conditionBlocks.map((block, index) => ({
        uuid: block.uuid,
        position: index + 1,
        binary_operator: index === 0 ? '' : block.binary_operator,
        conditions: block.conditions.map((f, subIndex) => {
          let value = f.value;
          if (relativeDates.includes(f.operator)) {
            value = moment().tz('UTC').toString().slice(0, 15);
          }
          return {
            uuid: f.uuid,
            binary_operator: subIndex === 0 ? '' : f.binary_operator,
            indicator: f.indicator,
            operator: f.operator,
            value: value,
            position: subIndex + 1,
            type: f.type,
          };
        }),
      })),
    };
    dispatch(applyFilters(updatedProfile));
  };

  useEffect(() => {
    props.loadMySubscriptionPlan();
    if (!q?.get('filterProfile')) {
      document.title = 'Threat Ranking - Silent Push';
    }
    if (q?.get('tag')) {
      updateTag(q?.get('tag'));
    }
    if (q?.get('row') && iocList) {
      let row = q?.get('row');
      setRowToHide(row[0]);
      setExpandedRowsKeys([q?.get('row')]);
      let foundRow = iocList?.find((ioc) => {
        return ioc?.uuid === row[0];
      });
      let rowIndex = iocList?.indexOf(foundRow);
      setRowIndex(rowIndex);
    }
    props.loadFilters();
    props.loadFilterProfiles();
    props.loadUser();
    props.loadAPIVersion();
    props.resetFilterProfile();

    pagination.page = 1;
    filterProfileApplied = null;
    const isFilterProfileApplied = !!filterProfileApplied;
    if (!isFilterProfileApplied?.name) {
      dispatch(
        changeTitle(
          'Threat Ranking',
          props?.total?.toLocaleString() + ' observables',
        ),
      );
    } else {
      dispatch(
        changeTitle(
          'Threat Ranking',
          props?.total?.toLocaleString() + ' observables',
        ),
      );
    }

    return () => {
      props.resetStixExportLimitedStatus();
      setFeedStateFilter('Feed');
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // listening to redux feed state value and updating local useState
    setFeedStateFilterValue(feedStateFilterCategory);
  }, [feedStateFilterCategory]);

  useEffect(() => {
    // listening to local feed state and updates redux store on change
    setFeedStateFilter(feedStateFilterValue);
  }, [feedStateFilterValue]);

  useEffect(() => {
    // filter feeds list by type (url, ip, domain) and set it in filteredFeedSources
    if (!feedType) {
      setFilteredFeedSources(filterSettings?.feedsources);
    } else {
      setFilteredFeedSources(
        filterSettings?.feedsources?.filter((feed) => {
          if (feedType?.includes(feed.type)) return feed;
        }),
      );
    }
  }, [feedType]);

  useEffect(() => {
    setFilteredFeedSources(filterSettings?.feedsources);
  }, [filterSettings.feedsources]);

  useEffect(() => {
    // this is if the openAdvancedFilter URL param is passed from left menu,
    // open in new tab for filter profile creation
    if (q?.get('openAdvancedFilter')) {
      if (
        props?.advancedFilterMenuOpen &&
        !window.location.search.includes('?openCreateNewAdvancedFilter=true')
      ) {
        props.toggleFilterSidebar(true);
      }
    } else if (window.location.search.includes('?openAdvancedFilter=true')) {
      if (
        props?.advancedFilterMenuOpen &&
        !window.location.search.includes('?openCreateNewAdvancedFilter=true')
      ) {
        props.toggleFilterSidebar(true);
      }
    }

    if (q?.get('filterProfile')) {
      const filterProfileToApply = filterProfiles.filter(
        (fp) => fp.uuid === q?.get('filterProfile'),
      );
      applyFilterProfile(filterProfileToApply);
    }
  }, [filterProfiles]);

  function scrollByRow(rowIndex) {
    let amountScrolled = rowIndex * 43;
    if (rowIndex <= 5) {
      amountScrolled = amountScrolled * 3;
    } else if (rowIndex > 5 && rowIndex <= 10) {
      amountScrolled = amountScrolled * 1.5;
    } else if (rowIndex > 10 && rowIndex <= 30) {
      amountScrolled = amountScrolled * 1.2;
    } else if (rowIndex > 30 && rowIndex <= 45) {
      amountScrolled = amountScrolled * 1.1;
    } else if (rowIndex > 45 && rowIndex <= 60) {
      amountScrolled = amountScrolled * 1.05;
    }
    document.body.scrollTop = amountScrolled; // For Safari
    if (pagination.pageSize === 100) {
      document.documentElement.scrollTop = amountScrolled;
    }
  }

  if (iocList && rowIndex) {
    scrollByRow(rowIndex);
  }

  useEffect(() => {
    const tag = props.tag;
    const feed = getQueryVariable('feed', props.location.search);
    const vendor = getQueryVariable('vendor', props.location.search);
    let feedState = getQueryVariable('feed_state', props.location.search);
    let feedsToFilterBy = new Set();
    let vendorsToFilterBy = new Set();

    if (feedState) {
      feedState = feedState.toLowerCase();
      feedState = feedState.charAt(0).toUpperCase() + feedState.slice(1);
      setFeedStateFilter(feedState);
      setFeedStateFilterValue(feedState);
    }

    function check() {
      //No cookie, run normal threat ranking
      if (!threat_ranking_cached_flag) {
        return true;
      }
      //There is cookie but it's expired. Run normal threat ranking
      else if (threat_ranking_cached_flag) {
        if (threat_ranking_cached_flag < Date.now()) {
          return true;
        }
        //There is flag and it's not expired yet
        else {
          return false;
        }
      }
      //Otherwise run from cache
      else {
        return false;
      }
    }

    if (feed) feedsToFilterBy.add(feed);
    if (vendor) vendorsToFilterBy.add(vendor);

    if (
      !(
        window.location.search?.includes('filterProfile')
        //&&
        //getQueryVariable('filterProfile', props.location.search) &&
        // currentlySelectedProfile
      )
      //||
      //q?.get('tag')
    ) {
      if (
        check() ||
        window.location.search?.includes('tag=') ||
        window.location.search?.includes('feed=') ||
        window.location.search?.includes('vendor=') ||
        window.location.search?.includes('newFp=') ||
        window.location.search?.includes('row=') ||
        process.env.REACT_APP_DISABLE_CACHE === 'true' ||
        (feedState !== undefined &&
          feedState !== 'Feed' &&
          !window.location.search?.includes('newFp='))
      ) {
        //The following if is to determine if previous filters/sorting needs to be applied when "navigating" on threat ranking
        if (window.location.search?.includes('row=')) {
          fetchData({
            pagination,
            filters: {
              ...filters,
              // feed: feedsToFilterBy.size > 0 ? [...feedsToFilterBy] : null,
              // vendor: vendorsToFilterBy.size > 0 ? [...vendorsToFilterBy] : null,
              // name: null,
              // type: null,
            },
            sorting: {
              ...sorting,
              // total: null,
              // totalCustom: null,
              // totalIoc: '-total_ioc',
              // totalSourceScore: '-total_source_score',
            },
            feed_state: feedState,
            tag: tag ? tag : q?.get('tag') ? q?.get('tag') : null,
          });
          paginationIocList({
            pagination,
            filters: {
              ...filters,
              // feed: feedsToFilterBy.size > 0 ? [...feedsToFilterBy] : null,
              // vendor: vendorsToFilterBy.size > 0 ? [...vendorsToFilterBy] : null,
              // name: null,
              // type: null,
            },
            sorting: {
              ...sorting,
              // total: null,
              // totalCustom: null,
              // totalIoc: '-total_ioc',
              // totalSourceScore: '-total_source_score',
            },
            feed_state: feedState,
            tag: tag ? tag : q?.get('tag') ? q?.get('tag') : null,
          });
        }
        //in this case, no previous filter/sorting is applied
        else {
          fetchData({
            pagination,
            filters: {
              ...filters,
              feed: feedsToFilterBy.size > 0 ? [...feedsToFilterBy] : null,
              vendor:
                vendorsToFilterBy.size > 0 ? [...vendorsToFilterBy] : null,
              name: null,
              type: null,
            },
            sorting: {
              total: null,
              totalCustom: null,
              totalIoc: '-total_ioc',
              totalSourceScore: '-total_source_score',
            },
            feed_state: feedState,
            tag: tag ? tag : q?.get('tag') ? q?.get('tag') : null,
          });
          paginationIocList({
            pagination,
            filters: {
              ...filters,
              feed: feedsToFilterBy.size > 0 ? [...feedsToFilterBy] : null,
              vendor:
                vendorsToFilterBy.size > 0 ? [...vendorsToFilterBy] : null,
              name: null,
              type: null,
            },
            sorting: {
              total: null,
              totalCustom: null,
              totalIoc: '-total_ioc',
              totalSourceScore: '-total_source_score',
            },
            feed_state: feedState,
            tag: tag ? tag : q?.get('tag') ? q?.get('tag') : null,
          });
        }
      }

      //Retrieve iocList and count from localStorage
      else {
        //Preventing mis-cached threatranking to be applied
        if (
          localStorage?.getItem('threat_ranking_data') &&
          localStorage?.getItem('threat_ranking_data') !== undefined &&
          localStorage?.getItem('threat_ranking_data') !== 'undefined' &&
          localStorage?.getItem('pagination_total') &&
          localStorage?.getItem('pagination_total') !== undefined &&
          localStorage?.getItem('pagination_total') !== 'undefined' &&
          JSON?.parse(localStorage?.getItem('threat_ranking_data'))?.length >
            0 &&
          JSON?.parse(localStorage?.getItem('pagination_total')) > 0
        ) {
          updateIocListFromCache({
            pagination,
            pagination: {
              ...defaultPagination,
            },
            filters: {
              ...defaultFilters,
            },
            sorting: {
              ...defaultSorting,
            },
            filterProfile: null,
            feed_state: 'Feed',
            tag: null,
          });
          paginationIocListFromCache({
            pagination: {
              ...defaultPagination,
            },
            filters: {
              ...defaultFilters,
            },
            sorting: {
              ...defaultSorting,
            },
            filterProfile: null,
            feed_state: 'Feed',
            tag: null,
          });
        } else {
          fetchData({
            pagination,
            filters: {
              ...filters,
              feed: feedsToFilterBy.size > 0 ? [...feedsToFilterBy] : null,
              vendor:
                vendorsToFilterBy.size > 0 ? [...vendorsToFilterBy] : null,
              name: null,
              type: null,
            },
            sorting: {
              total: null,
              totalCustom: null,
              totalIoc: '-total_ioc',
              totalSourceScore: '-total_source_score',
            },
            feed_state: feedStateFilterValue,
            tag: tag ? tag : q?.get('tag') ? q?.get('tag') : null,
          });
          paginationIocList({
            pagination,
            filters: {
              ...filters,
              feed: feedsToFilterBy.size > 0 ? [...feedsToFilterBy] : null,
              vendor:
                vendorsToFilterBy.size > 0 ? [...vendorsToFilterBy] : null,
              name: null,
              type: null,
            },
            sorting: {
              total: null,
              totalCustom: null,
              totalIoc: '-total_ioc',
              totalSourceScore: '-total_source_score',
            },
            feed_state: feedStateFilterValue,
            tag: tag ? tag : q?.get('tag') ? q?.get('tag') : null,
          });
        }
      }
    }
    setCheckedFeedsFilter({ [feed]: true });
    setCheckedVendorsFilter({ [vendor]: true });
  }, [props.location, props.location.search, q?.get('tag')]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.paginationStatus === STATUS.LOADED) {
      setCurrentUUID(
        window.location?.search
          ?.split('?filterProfile=')?.[1]
          ?.split('&tag=')?.[0]
          ?.replace('?openAdvancedFilter=true', '')
          ?.replace('?openCreateNewAdvancedFilter=true', ''),
      );
      const activeFilterProfile = filterProfiles?.filter(
        (fp) => fp?.uuid === currentUUID,
      )[0];

      if (
        window.location.search.includes('?filterProfile=') &&
        activeFilterProfile
      ) {
        dispatch(
          changeTitle(
            'Threat Ranking',
            props.total?.toLocaleString() + ' observables',
          ),
        );
      } else {
        dispatch(
          changeTitle(
            'Threat Ranking',
            props.total?.toLocaleString() + ' observables',
          ),
        );
        if (!q?.get('filterProfile')) {
          document.title = 'Threat Ranking - Silent Push';
        }
      }
    }
  }, [props.paginationStatus, props.location, props.total]);

  const fetchData = (params) => {
    updateIocList(params);
    incrementUIRequestsCounter();
  };

  const NoDataIcon = (props) => <Icon component={no_results} {...props} />;
  function constructSortingOptions(sortItem, sorted) {
    let order = null;
    if (sortItem.order === 'ascend') {
      order = '';
    } else if (sortItem.order === 'descend') {
      order = '-';
    }
    const field =
      sortItem.field === 'total'
        ? sortItem.field
        : humps.decamelize(sortItem.field);
    sorted[sortItem.field] = `${order}${field}`;
    return sorted;
  }

  const updateFilterAndSorting = (pagination, updatedFilters, sorting) => {
    let sorted = {};
    if (sorting.order) {
      sorted = constructSortingOptions(sorting, sorted);
      mixpanel.track('Column Sort', {
        location: 'threat ranking',
        column: sorting?.field + ' ' + sorting?.order,
      });
    } else if (sorting?.length && sorting?.length > 1) {
      for (var index in sorting?.reverse()) {
        let sort = sorting[index];
        sorted = constructSortingOptions(sort, sorted);
      }
    }
    setFeedType(updatedFilters.type); // always an array like ["url",]
    fetchData({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        type: updatedFilters.type,
        feed: updatedFilters.sourceName,
        vendor: updatedFilters.sourceVendorName,
      },
      filterProfile: filterProfileApplied,
      sorting: sorted,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
    paginationIocList({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        type: updatedFilters.type,
        feed: updatedFilters.sourceName,
        vendor: updatedFilters.sourceVendorName,
      },
      filterProfile: filterProfileApplied,
      sorting: sorted,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
  };

  const showManualExportModal = () => {
    setExportLimit(100);
    setManualExportModalVisible(true);
    mixpanel.track('Manual Export Attempted', {
      location: 'threat ranking',
      filtered: feedStateFilterValue,
    });
  };

  const showAutomatedExportModal = () => {
    setAutomatedExportModalVisible(true);
    incrementUIRequestsCounter();
    mixpanel.track('Automated Export Attempted', {
      location: 'threat ranking',
      filtered: feedStateFilterValue,
    });
  };

  const handleManualExportModalCancel = () => {
    setManualExportModalVisible(false);
  };

  const handleShowAutomatedExportModal = (visible) =>
    setAutomatedExportModalVisible(visible);

  const export_fields = {
    name: 'name',
    uuid: 'uuid',
    type: 'type',
    lastSeenOn: 'last seen',
    sourceName: 'feed',
    sourceVendorName: 'vendor',
    iocTemplate: 'ioc template',
    totalIoc: 'total ioc',
    totalCustom: 'total customer',
    totalSourceScore: 'total feed',
    total: 'total',
    // "active",
  };

  const normalize_export_data = (row) => {
    const fields = Object.keys(export_fields);
    return Object?.fromEntries(
      Object?.entries(row)
        ?.filter(([key]) => fields?.includes(key))
        ?.sort(function (a, b) {
          return fields?.indexOf(a?.[0]) - fields?.indexOf(b?.[0]);
        })
        ?.map((entry) => {
          const label = Object.entries(export_fields).filter(
            (f) => f[0] === entry[0],
          );
          return [label[0][1], entry[1]];
        }),
    );
  };

  const handleModalSubmit = () => {
    const ioc = {
      pagination: pagination,
      filters: filters,
      sorting: sorting,
      feed_state: feedStateFilterValue,
      distinct: exportDeduplicateState,
    };

    if (exportLimit > 0 && exportLimit <= 100 && !exportSwitchState) {
      const sliced_iocList = iocList?.slice(0, exportLimit);
      const csv = [
        Object.values(export_fields),
        ...sliced_iocList?.map((row) =>
          Object.values(normalize_export_data(row)),
        ),
      ]?.join('\r\n');
      const csvBlob = new Blob([csv], {
        type: 'text/csv',
      });
      saveAs(csvBlob, 'threat_ranking_page_' + pagination.page + '.csv');
    } else {
      props.exportListToCSV(ioc, exportSwitchState, exportLimit, props.total);
    }
    incrementUIRequestsCounter();
    setManualExportModalVisible(false);
    // track_links() doesn't work, probably because the <Button> component isn't a link
    mixpanel.track('Export', {
      location: 'threat ranking',
      advanced: exportSwitchState,
      format: 'CSV',
    });
  };

  const handleSTIXExportSubmit = () => {
    const params = {
      pagination: pagination,
      filters: filters,
      sorting: sorting,
      distinct: exportDeduplicateState,
    };

    if (exportLimit > 0 && exportLimit <= 100) {
      props.exportListToSTIXLimited(params, exportLimit);
    } else {
      props.exportListToSTIX(
        params,
        exportSwitchState,
        exportLimit,
        props.total,
      );
    }
    incrementUIRequestsCounter();
    setManualExportModalVisible(false);
    mixpanel.track('Export', {
      location: 'threat ranking',
      advanced: exportSwitchState,
      format: 'STIX',
    });
  };

  useEffect(() => {
    if (props.stixDataStatus === STATUS.LOADED) {
      saveAs(
        props.stixData,
        'threat_ranking_page_' + pagination.page + '.json',
      );
    }
  }, [props.stixDataStatus]);

  const handleJSONExportSubmit = () => {
    const ioc = {
      pagination: pagination,
      filters: filters,
      sorting: sorting,
      distinct: exportDeduplicateState,
    };
    if (exportLimit > 0 && exportLimit <= 100 && !exportSwitchState) {
      const sliced_iocList = iocList?.slice(0, exportLimit);
      const fileData = JSON.stringify(
        sliced_iocList?.map((row) => normalize_export_data(row)),
      );
      const blob = new Blob([fileData], { type: 'text/plain' });
      saveAs(blob, 'threat_ranking_page_' + pagination.page + '.json');
    } else {
      props.exportListToJSON(ioc, exportSwitchState, exportLimit, props.total);
    }
    incrementUIRequestsCounter();
    setManualExportModalVisible(false);
    mixpanel.track('Export', {
      location: 'threat ranking',
      advanced: exportSwitchState,
      format: 'JSON',
    });
  };

  const handleClearAllClick = () => {
    setCheckedFeedsFilter(null);
    setCheckedVendorsFilter(null);
    clearFeedInputFilter();
    clearVendorInputFilter();
    setFeedStateFilterValue('Feed');
    updateTag(null);
    clearFilterProfile();
    setFilteredFeedSources(filterSettings.feedsources);

    // fetchData({
    //   pagination: {
    //     ...defaultPagination,
    //   },
    //   filters: {
    //     ...defaultFilters,
    //   },
    //   sorting: {
    //     ...defaultSorting,
    //   },
    //   filterProfile: null,
    //   feed_state: 'Feed',
    // });
    // paginationIocList({
    //   pagination: {
    //     ...defaultPagination,
    //   },
    //   filters: {
    //     ...defaultFilters,
    //   },
    //   sorting: {
    //     ...defaultSorting,
    //   },
    //   filterProfile: null,
    //   feed_state: 'Feed',
    // });

    // dispatch(applyFilters(null));

    if (props.advancedFilterMenuOpen) {
      history.push('/');
    } else {
      history.push('/?openAdvancedFilter=true');
    }

    mixpanel.track('Clear Filters', {
      location: 'threat ranking',
    });
  };

  const handleDateFilterSubmit = (dates) => {
    if (!dates || !dates.length) return;
    fetchData({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        last_seen_from: dates[0]
          .utcOffset(0)
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toISOString(),
        last_seen_to: dates[1]
          .utcOffset(0)
          .set({ hour: 23, minute: 59, second: 59, millisecond: 99 })
          .toISOString(),
      },
      filterProfiles: filterProfileApplied,
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
    paginationIocList({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        last_seen_from: dates[0]
          .utcOffset(0)
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toISOString(),
        last_seen_to: dates[1]
          .utcOffset(0)
          .set({ hour: 23, minute: 59, second: 59, millisecond: 99 })
          .toISOString(),
      },
      filterProfile: filterProfileApplied,
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
  };

  const handleDateFilterReset = () => {
    fetchData({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        last_seen_from: null,
        last_seen_to: null,
      },
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
    paginationIocList({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        last_seen_from: null,
        last_seen_to: null,
      },
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
  };

  const handleNameFilterSubmit = (name, filterProfile) => {
    if (!name || !name.trim().length) return;
    fetchData({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        name: name.trim(),
      },
      filterProfile: filterProfileApplied,
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
    paginationIocList({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        name: name.trim(),
      },
      filterProfile: filterProfileApplied,
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
    mixpanel.track('Simple Filter', {
      location: 'threat ranking',
      filter_type: name,
    });
  };

  const handleVendorFilterSubmit = (vendors) => {
    fetchData({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        vendor: vendors,
      },
      filterProfile: filterProfileApplied,
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
    paginationIocList({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        vendor: vendors,
      },
      filterProfile: filterProfileApplied,
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
  };

  const handleVendorFilterReset = () => {
    setCheckedVendorsFilter(null);
    fetchData({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        vendor: null,
      },
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
    paginationIocList({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        vendor: null,
      },
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
  };

  const handleFeedFilterSubmit = (feeds) => {
    fetchData({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        feed: feeds,
      },
      filterProfile: filterProfileApplied,
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
    paginationIocList({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        feed: feeds,
      },
      filterProfile: filterProfileApplied,
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
  };
  const handleFeedFilterReset = () => {
    setCheckedFeedsFilter(null);
    fetchData({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        feed: null,
      },
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
    paginationIocList({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        feed: null,
      },
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
  };

  const handleFeedTypeFilterChange = (feed_state) => {
    fetchData({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
      },
      filterProfile: filterProfileApplied,
      sorting,
      feed_state: feed_state,
      tag: props.tag,
    });
    paginationIocList({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
      },
      filterProfile: filterProfileApplied,
      sorting,
      feed_state: feed_state,
      tag: props.tag,
    });
  };

  const handleNameFilterReset = () => {
    fetchData({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        name: null,
      },
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
    paginationIocList({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        name: null,
      },
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
  };

  const handleNumberRangeSubmit = (fieldName, range) => {
    fetchData({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        [fieldName]: range,
      },
      filterProfile: filterProfileApplied,
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
    paginationIocList({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        [fieldName]: range,
      },
      filterProfile: filterProfileApplied,
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
  };

  const handleNumberRangeReset = (fieldName) => {
    fetchData({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        [fieldName]: [0, 100],
      },
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
    paginationIocList({
      pagination: {
        ...props.pagination,
        page: 1,
      },
      filters: {
        ...filters,
        [fieldName]: [0, 100],
      },
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
    });
  };

  function onPageChange(current, pageSize) {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
    const newPagination = {
      ...pagination,
      page: current,
      pageSize,
    };
    fetchData({
      pagination: newPagination,
      filters,
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
      filterProfile: filterProfileApplied,
    });
    paginationIocList({
      pagination: newPagination,
      filters,
      sorting,
      feed_state: feedStateFilterValue,
      tag: props.tag,
      filterProfile: filterProfileApplied,
    });
    if (pagination.page < current) {
      mixpanel.track('Next Page', {
        location: 'threat ranking',
        page: current,
      });
    } else {
      mixpanel.track('Previous Page', {
        location: 'threat ranking',
        page: current,
      });
    }
  }

  const columns = IOCData.columns({
    props,
    status,
    filters,
    sorting,
    sortOrder,
    filterSettings,
    checkedVendorsFilter,
    setCheckedVendorsFilter,
    setClearVendorInputFilter,
    checkedFeedsFilter,
    setCheckedFeedsFilter,
    setClearFeedInputFilter,
    feedType,
    setFeedType,
    filteredFeedSources,
    handleDateFilterSubmit,
    handleDateFilterReset,
    handleNameFilterSubmit,
    handleNameFilterReset,
    handleNumberRangeSubmit,
    handleNumberRangeReset,
    handleFeedFilterSubmit,
    handleFeedFilterReset,
    handleVendorFilterSubmit,
    handleVendorFilterReset,
  });

  // eslint-disable-next-line no-unused-vars
  const [rowToHide, setRowToHide] = useState(-1);

  function onTableRowExpand(expanded, record) {
    const keys = [];
    if (expanded) {
      keys.push(`${record.uuid}`);
      setRowToHide(record.uuid);
      mixpanel.track('Threat Detail Open', {
        ioc_type: record?.type,
        feed_name: record?.source_name,
        feed_vendor: record?.feeds?.vendor,
      });
    }

    setExpandedRowsKeys(keys);
    if (q?.get('row') && iocList) {
      createBrowserHistory({ forceRefresh: false }).replace({
        row: undefined,
      });
      let foundRow = iocList?.find((ioc) => {
        return ioc?.uuid === record?.uuid;
      });
      let rowIndex = iocList?.indexOf(foundRow);
      setRowIndex(rowIndex);
    }
    incrementUIRequestsCounter();
  }

  const loadAdvancedFilterSidebar = () => {
    mixpanel.track('Filter Open');
    if (!selectedProfile) {
      props.loadFilters();
      props.loadFilterProfiles();
    }

    props.toggleFilterSidebar();
  };

  const tablePagination = (
    <Pagination
      showSizeChanger={false}
      current={pagination.page}
      total={props.total}
      pageSize={pagination.pageSize}
      pageLoading={props.paginationStatus === STATUS.LOADING}
      onChange={onPageChange}
    />
  );

  const getUrl = () => {
    let hostName = window.location.protocol + '//' + window.location.host;
    let newActiveThreatRankingEndpoint =
      activeThreatRankingEndpoint?.replace('&limit=100&', '&limit=1000&') +
      '&advanced=simple';
    return hostName + newActiveThreatRankingEndpoint;
  };

  return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
    <div
      className={cx(styles.container, !props.collapsed && styles.not_collapsed)}
    >
      <Modal
        footer={null}
        title="Manual Export"
        open={
          manualExportModalVisible || props.stixDataStatus === STATUS.LOADING
        }
        onCancel={handleManualExportModalCancel}
      >
        <Row gutter={[8, { xs: 8, sm: 8, lg: 8 }]}>
          <Col xs={14}>Export simple or advanced IOC data:</Col>
          <Col xs={10}>
            <Switch
              checked={exportSwitchState}
              checkedChildren="Advanced"
              unCheckedChildren="Simple"
              onChange={(checked) => setExportSwitchState(checked)}
            />
          </Col>
          <Col xs={14}>Deduplicate observables:</Col>
          <Col xs={10}>
            <Switch
              checked={exportDeduplicateState}
              checkedChildren="Yes"
              unCheckedChildren="No"
              onChange={(checked) => setExportDeduplicateState(checked)}
            />
          </Col>
          <Col xs={14}>Export number of rows (maximum 10,000):</Col>
          <Col xs={10}>
            <InputNumber
              min={0}
              max={10000}
              step={100}
              controls={true}
              value={exportLimit}
              size={'small'}
              status={(exportLimit > 10000 || exportLimit < 0) && 'error'}
              onChange={(value) => setExportLimit(value || 10000)}
            />
          </Col>
        </Row>
        {exportDeduplicateState && (
          <Alert
            style={{ marginTop: '10px' }}
            description={
              <>
                Repeated observables will be removed.
                <br />
                <b>Note:</b> total exported data and sorting won't match.
              </>
            }
            type="info"
            showIcon
            banner
          />
        )}
        <div className="export_button_container">
          <Button
            onClick={() => handleManualExportModalCancel()}
            className="tab_cancel"
          >
            Cancel
          </Button>
          <Button
            role={'button2'}
            disabled={exportSwitchState === true ? true : false}
            onClick={() => handleSTIXExportSubmit()}
            type="primary"
            className="tab_save"
            loading={props.stixDataStatus === STATUS.LOADING}
          >
            STIX
          </Button>
          <Button
            role={'button1'}
            onClick={() => handleJSONExportSubmit()}
            type="primary"
            className="tab_save"
          >
            JSON
          </Button>
          <Button
            onClick={() => handleModalSubmit()}
            type="primary"
            className="tab_save"
          >
            CSV
          </Button>
        </div>
      </Modal>
      <CopyEndpoint
        // filter profile will be passed in body of request so it can reflect the real TR in case conditions change

        fpuuid={filterProfileApplied?.uuid}
        endpoint={getUrl()
          ?.split('&')
          ?.filter((u) => u?.indexOf('filter_profile=') == -1)
          ?.join('&')}
        body={endpointParams?.body}
        title="Automate Export"
        description={
          <>
            The endpoint below returns a list of observables from the threat
            ranking with saved advanced and/or simple filters and sorting from
            the table. Paste this endpoint to your security tool (SOAR,
            Sentinel, Microsoft Azure etc). To modify the endpoint use
            instructions from our&nbsp;
            <a href="http://docs.silentpush.com">API documentation</a>
          </>
        }
        visible={automatedExportModalVisible}
        handleShowAutomateExportModal={handleShowAutomatedExportModal}
      />

      <div className={styles.topActionsContainer}>
        <AdvancedFilterButton
          filterSidebarOpen={props.advancedFilterMenuOpen}
          filterProfileApplied={filterProfileApplied}
          toggleFilterSidebar={props.toggleFilterSidebar}
        />

        {props.mySubscriptionPlan?.has_access_to_threat_ranking &&
          (props.paginationStatus != STATUS.LOADED ? (
            <div className={styles.paginationSpinnerContainer}>
              <Spin size="small" />
            </div>
          ) : (
            tablePagination
          ))}
      </div>

      <div className={styles.advancedFiltersContainer}>
        {props.mySubscriptionPlan?.has_access_to_advanced_filter && (
          <AdvancedFilterView
            toggleFilterSidebar={props.toggleFilterSidebar}
            loadAdvancedFilterSidebar={loadAdvancedFilterSidebar}
            filterSidebarOpen={!props.collapsed}
          />
        )}
      </div>

      {props.mySubscriptionPlan?.has_access_to_threat_ranking ? (
        <>
          <Table
            locale={{
              emptyText:
                props.status === STATUS.LOADING ? (
                  <div style={{ height: '150px' }}></div>
                ) : (
                  <span>
                    <NoDataIcon style={{ fontSize: 32 }} />
                    <p
                      style={{
                        color: 'rgba(255, 255, 255, 0.95)',
                        fontFamily: 'TT Hoves',
                        fontWeight: 600,
                        fontSize: '16px',
                        lineHeight: '19px',
                        fontStyle: 'normal',
                      }}
                    >
                      Threat Ranking list is empty
                    </p>
                    <p
                      style={{
                        color: 'rgba(255, 255, 255, 0.95)',
                      }}
                    >
                      To get threat results click on{' '}
                      <span
                        style={{
                          color: '#3C9AE8',
                          display: 'inline',
                        }}
                        onClick={handleClearAllClick}
                      >
                        clear all filters
                      </span>
                      , or change your filter profile settings in{' '}
                      <span
                        style={{
                          color: '#3C9AE8',
                          display: 'inline',
                        }}
                        onClick={() => props.toggleFilterSidebar(true)}
                      >
                        advanced filter.
                      </span>{' '}
                    </p>
                  </span>
                ),
            }}
            onRow={(record, rowIndex) => ({
              onClick: () => {
                // eslint-disable-next-line no-unused-vars
                let amountScrolled = rowIndex * 58;
                if (rowIndex <= 5) {
                  amountScrolled = amountScrolled * 3;
                } else if (rowIndex > 5 && rowIndex <= 10) {
                  amountScrolled = amountScrolled * 1.5;
                } else if (rowIndex > 10 && rowIndex <= 30) {
                  amountScrolled = amountScrolled * 1.2;
                } else if (rowIndex > 30 && rowIndex <= 45) {
                  amountScrolled = amountScrolled * 1.1;
                } else if (rowIndex > 45 && rowIndex <= 60) {
                  amountScrolled = amountScrolled * 1.05;
                }

                //document.body.scrollTop = amountScrolled; // For Safari
                if (pagination.pageSize === 100) {
                  //  document.documentElement.scrollTop = amountScrolled;
                }
              },
            })}
            columns={columns}
            dataSource={iocList}
            pagination={false}
            onChange={updateFilterAndSorting}
            rowKey={(record) => `${record.uuid}`}
            loading={tableLoading}
            className={styles['threat_ranking_table']}
            //onExpand={onTableRowExpand}
            title={() => (
              <ThreatRankingHeader
                activeThreatRankingEndpoint={activeThreatRankingEndpoint}
                showManualExportModal={showManualExportModal}
                showAutomatedExportModal={showAutomatedExportModal}
                handleClearAllClick={handleClearAllClick}
                loadAdvancedFilterSidebar={loadAdvancedFilterSidebar}
                filterSidebarOpen={!props.collapsed}
                handleNameFilterSubmit={handleNameFilterSubmit}
                handleNameFilterReset={handleNameFilterReset}
                handleFeedTypeFilterChange={handleFeedTypeFilterChange}
                setFeedStateFilterValue={setFeedStateFilterValue}
                feedStateFilterValue={feedStateFilterValue}
              />
            )}
            //rowClassName={(expanded) => (expanded ? 'expandedRow' : 'hidden')}
            rowClassName={(record, index) => {
              const uniqueKey = `${record.uuid}`;
              if (expandedRowsKeys.indexOf(uniqueKey) !== -1) {
                return styles['table-row-hidden'];
              }
              return styles['table-row-show'];
            }}
            expandedRowKeys={expandedRowsKeys}
            expandedRowRender={(record, index, indent, expanded) =>
              expanded && (
                <IOCDetail
                  collapsed={props.collapsed}
                  toggleFalsePositive={props.toggleFalsePositive}
                  toggleTruePositive={props.toggleTruePositive}
                  toggleLeftMenu={props.toggleLeftMenu}
                  history={props.history}
                  clearScoreDetails={props.clearScoreDetails}
                  loadScoreDetails={props.loadScoreDetails}
                  loadNewScoreDetails={props.loadNewScoreDetails}
                  detailStatus={props.detailStatus}
                  newDetailsStatus={props.newDetailsStatus}
                  deleteStatus={props.deleteStatus}
                  scoreDetails={props.scoreDetails}
                  newScoreDetails={props.newScoreDetails}
                  record={record}
                  expanded={expanded}
                  loadMergeAPIExploreIPDensity={
                    props.loadMergeAPIExploreIPDensity
                  }
                  exploreAPIIPDensityDetails={props.exploreAPIIPDensityDetails}
                  ipDensityStatus={props.ipDensityStatus}
                  deleteIOC={props.deleteIOC}
                  exportSingleIOC={props.exportSingleIOC}
                  setExpandedRowsKeys={setExpandedRowsKeys}
                  key={`${record.uuid}`}
                  resetEnrichment={props.resetEnrichment}
                  mySubscriptionPlan={props.mySubscriptionPlan}
                />
              )
            }
            expandRowByClick
            // eslint-disable-next-line react/jsx-no-duplicate-props
            onExpand={(record, expanded) => onTableRowExpand(record, expanded)}
            expandIcon={({ expanded, onExpand, record }) => (
              <Tooltip title="Open details">
                <RightOutlined onClick={() => onExpand(record, expanded)} />
              </Tooltip>
            )}
          />
          <div className={styles.bottomTablePagination}>{tablePagination}</div>
        </>
      ) : (
        <PermissionDeniedPage />
      )}

      <Divider />
      <VersionCheck parentComponentStatus={props.status} />
    </div>
  ) : (
    <LoadingSilentPush size={80} positionCenter />
  );
}
export default Home;
